<template>
    <div>
    </div>
</template>
<script>
export default {
    data(){
        return {  
        }
    },

    created () {
       
    },
    mounted () {
        if(document.body.previousElementSibling.tagName.toLowerCase() == 'script' && document.body.previousElementSibling.src == 'http://kefu.easemob.com/webim/easemob.js?configId=15fca919-b918-4a78-81ae-2d635c4bf552'){
            return;
        }else {
            var scr = document.createElement("script");
            scr.src = '//kefu.easemob.com/webim/easemob.js?configId=15fca919-b918-4a78-81ae-2d635c4bf552';
            document.documentElement.insertBefore(scr, document.body);
            window.easemobim = window.easemobim || {};
            easemobim.config = {
                configId: '15fca919-b918-4a78-81ae-2d635c4bf552',
                buttonText: '联系客服',
                dialogWidth: '650px',
                dialogHeight: '650px',
                dialogPosition: { x: '50px', y: '50px' }
            };
        }
    }
}

</script>
<style lang="less">

</style>

